import { create } from "zustand";

export const useAudioList = ((set) => ({
  celebrateAudios: [
    "/sounds/celebrate/celebrate1.mp3",
    "/sounds/celebrate/celebrate2.mp3",
    "/sounds/celebrate/celebrate3.mp3",
    "/sounds/celebrate/celebrate4.mp3",
    "/sounds/celebrate/celebrate5.mp3",
    "/sounds/celebrate/celebrate6.mp3",
    "/sounds/celebrate/celebrate7.mp3",
    "/sounds/celebrate/celebrate8.mp3",
    "/sounds/celebrate/celebrate9.mp3",
    "/sounds/celebrate/celebrate10.mp3",
    "/sounds/celebrate/celebrate11.mp3",
    "/sounds/celebrate/celebrate12.mp3",
    "/sounds/celebrate/celebrate13.mp3",
    "/sounds/celebrate/celebrate14.mp3",
    "/sounds/celebrate/celebrate15.mp3",
    "/sounds/celebrate/celebrate16.mp3",
    "/sounds/celebrate/celebrate17.mp3",
    "/sounds/celebrate/celebrate18.mp3",
    "/sounds/celebrate/celebrate19.mp3",
    "/sounds/celebrate/celebrate20.mp3",
    "/sounds/celebrate/celebrate21.mp3",
    "/sounds/celebrate/celebrate22.mp3",
  ],
  chaching: ["/sounds/chaching.mp3"],
  afcaAudios: [
    "/sounds/afca/afca1.mp3",
    "/sounds/afca/afca2.mp3",
    "/sounds/afca/afca3.mp3",
    "/sounds/afca/afca4.mp3",
    "/sounds/afca/afca5.mp3",
  ],
  background2: ['/sounds/background2.mp3'],
  backgroundMusic: [
    '/sounds/backgroundmusic7.mp3', 
    '/sounds/background-music.mp3', 
    '/sounds/background8.mp3',
  ],
  noMusic: ['/sounds/nooo.mp3']

}));

export const useAudio = create()((set) => ({
  audioURL: ["/sounds/background-music.mp3"],
  audioOff: true,
  setAudioURL: (url) => set(() => ({ audioURL: url })),
  setAudioStatus: (status) => set(() => ({ audioOff: status })),
}));
